import type { GQL_ID } from '@@partner:types:graphql'

import gql from 'graphql-tag'

interface CategoryBranch {
  id: GQL_ID
  name: string
  childrens: Omit<CategoryBranch, 'childrens'>[]
}

export interface CategoriesBranchQueryVariables {
  shop_id: GQL_ID
  parent_id?: GQL_ID
}

export interface CategoriesBranchQuery {
  categoriesBranch: CategoryBranch[]
}

export const GQL_QUERY_CATEGORIES_BRANCH = gql`
  query($shop_id: ID!, $parent_id: ID) {
    categoriesBranch(shop_id: $shop_id, parent_id: $parent_id) {
      id
      name
      childrens {
        id
        name
      }
    }
  }
`
